module.exports = __webpack_public_path__ + "static/media/button.cf4dcbe2.png";